declare const __BUILD_YEAR__: number;

/**
 * Current year that is safe at module scope. Cloudflare Workers freeze Date at
 * the Unix epoch during module initialisation, which rendered "1970" in titles;
 * fall back to the build year in that case.
 */
export function currentYear(): number {
  const y = new Date().getFullYear();
  if (y >= 2000) return y;
  return typeof __BUILD_YEAR__ === "number" ? __BUILD_YEAR__ : 2026;
}
